<template>
  <section class="scrollable padder">
    <div v-if="loading" class="loading">Loading&#8230;</div>
    
    <section class="panel panel-default">
     
      <div class="modal-body">
        <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(addEdit)" method="post">
          <div class="row">  
          <div class="col-md-6">
             <ValidationProvider
               name="Customer Name"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="customer-name">
                Customer Name <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="customer-name"
                v-model="customerName"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Customer Name"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-6">
                <ValidationProvider name="contact person" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Contact Person</label>
                 <input
                type="text"
                class="form-control"
                id="contact-person"
                v-model="contactPerson"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid name"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Contact Person"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          <div class="col-sm-12">
             <ValidationProvider
               name="Customer Address"
                  rules="required"
                  v-slot="{ errors }"
               >
            <div class="form-group">
              <label for="address">
                Address <span class="required-color">*</span></label
              >
              <input
                class="form-control"
                type="text"
                id="address"
                v-model="customerAddress"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid address"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Customer Address"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
          
                </ValidationProvider>
          </div>
              <div class="col-md-4">
                <ValidationProvider name="city" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> City</label>
                 <input
                type="text"
                class="form-control"
                id="city"
                v-model="customerCity"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid city anme"
                data-parsley-trigger="keyup"
                value=""
                placeholder="City"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="PO Box" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> P.O Box</label>
                 <input
                type="text"
                class="form-control"
                id="poBox"
                v-model="customerPO"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid P.O Box number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="P.O Box"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-4">
                <ValidationProvider name="payment-term" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Country</label>
                  <select
                    class="form-control"
                    v-model="customerCountry"
                    name="payment_term"
                    style="width: 100%;"
                  >
                    <option id="term" selected value=""
                      >Choose Country</option
                    >
                    <option
                      v-for="country in countryList"
                      :key="country"
                      v-bind:value="country"
                      >{{ country }}</option
                    >
                  </select>
                   <span style="color:red">{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="phone" rules="required" v-slot="{ errors }">
                <div class="form-group">
                  <label> Phone</label>
                 <input
                type="text"
                id="phone"
                class="form-control"
                v-model="customerPhone"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid phone number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Phone"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
              <div class="col-md-6">
                <ValidationProvider name="mobile" rules="" v-slot="{ errors }">
                <div class="form-group">
                  <label> Mobile</label>
                 <input
                type="text"
                class="form-control"
                id="mobile"
                v-model="customerMobile"
                autocomplete="off"
                data-parsley-pattern-message="This is not a valid mobile number"
                data-parsley-trigger="keyup"
                value=""
                placeholder="Mobile"
              />
               <p style="color:red">{{ errors[0] }}</p>
            </div>
              </ValidationProvider>
              </div>
          </div>
          <div class="modal-footer" style="text-align: right">
           
            <button
              :disabled="saveCat"
              id="btn_save"
              type="submit"
              class="btn btn-success  text-center  "
            >
              Save
            </button>
             <a
              v-on:click="$emit('hide-form')"
              class="btn btn-danger  text-center  "
            >
              Close
            </a>
          </div>
        </form>
        </ValidationObserver>
      </div>
      
    </section>
  </section>
</template>

<script>
import api from "../api";
import config from '../config'

export default {
  props: ["customerId"],
  name: "AddCustomer",
  data() {
    return {
      saveCat: false,
      itemId: '',
      customerName: '',
      contactPerson: '',
      customerAddress: '',
      countryList: config.countryList,
      customerCity: '',
      customerPO: '',
      customerCountry: '',
      customerPhone: '',
      customerMobile: '',
      errors : [],
      loading: false,
    };
  },
  methods: {
    addEdit() {
       this.loading = false
      this.saveCat = true;
      this.itemId = this.$props.customerId;
      this.errors = []
      if (!this.customerName) {
        this.errors.push("Customer Name is required.");
      }
      if(!this.errors.length){
      const addItem = {
        "customer-form": {
          customer_id: this.itemId,
          customer_name: this.customerName,
          contact_person: this.contactPerson,
          customer_city: this.customerCity,
          customer_po: this.customerPO,
          customer_country: this.customerCountry,
          customer_phone: this.customerPhone,
          customer_mobile: this.customerMobile,
          customer_address: this.customerAddress
        },
      };
      if (this.itemId > 0) {
        api
          .request("post", "GeneralApis/edit_customer", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Updated");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      } else {
        api
          .request("post", "GeneralApis/add_customer", addItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              alert("Succesfully Added");
              this.$emit("hide-form");
              this.$emit("list-items");
            }
          });
      }
      }
    },
    getCustomer: function() {
      var customer_id = this.$props.customerId;
        (this.customerName = ""),
        (this.contactPerson = ""),
        (this.customerCity = ""),
        (this.customerPO = ""),
        (this.customerCountry = ""),
        (this.customerMobile = ""),
        (this.customerAddress = ""),
        (this.customerPhone = ""),
        (this.itemId = 0);
      if (customer_id > 0) {
        this.itemId = customer_id;

        const getItem = {
          filter: {
            customer_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_customers", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const customerList = data.customerList[0];
              this.customerName = customerList.customer_name;
              this.customerAddress = customerList.customer_address;
              this.customerPhone = customerList.customer_phone;
              this.contactPerson = customerList.contact_person;
              this.customerCity = customerList.customer_city;
              this.customerPO = customerList.customer_po;
              this.customerCountry = customerList.customer_country;
              this.customerPhone = customerList.customer_phone;
              this.customerMobile = customerList.customer_mobile;
            }
          });
      }
    },
  },
  mounted() {
    this.getCustomer();
  },
};
</script>
